import { Typography } from "@material-ui/core";
import { Grid, Chip } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Ratings from "../../../constants/Rating";
import CompanyChart from "../../search-results/components/CompanyChart";
import Financials from "./Financials";
import KeyExectives from "./KeyExecutive";

export default function GeneralInfo(props) {
  const { data, ISIN, Company } = props;
  const description = data?.Description ? data?.Description : "";
  const website = data?.Websites ? data?.Websites : "";
  const financials = data?.Financials ? data?.Financials[0] : {};
  const keyExectives = data?.KeyExectives;
  const t = props.t;
  // const states = useSelector((state) => state.states.value);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  // const companies = states?.companies[states?.companies.length - 1]
  //   ? states?.companies[states?.companies.length - 1]
  //   : [];
  // const [index, setIndex] = useState(
  //   companies?.findIndex((company) => company.ISIN === ISIN)
  // );

  const [yearlyView, setYearlyView] = useState(false);
  const [monthlyView, setMonthlyView] = useState(false);
  const [changeGraph, setChangeGraph] = useState(false);

  // useEffect(() => {
  //   setIndex(companies?.findIndex((company) => company.ISIN === ISIN));
  // }, [ISIN]);

  return (
    <div
      style={{
        margin: isDesktopOrLaptop
          ? "64px 30px 32px 98px"
          : "0px 12px 32px 10px",
        display: "flex",
      }}
    >
      {isDesktopOrLaptop ? (
        <>
          <Grid item xs={"auto"}>
            {Company?.valuation ||
            Company?.future ||
            Company?.past ||
            Company?.health ||
            Company?.dividend ? (
              <div style={{ height: "200px", paddingBottom: "32px" }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    backgroundColor: "#f8f8f8",
                    borderRadius: "15px",
                    padding: "15px 15px 16px",
                    boxShadow: "0 2px 7px 0 #0000001f",
                    width: "268px",
                    marginRight: "30px",
                  }}
                >
                  <Ratings
                    value={parseInt(Company?.valuation)}
                    label={t("fair_price")}
                    fontSize="10px"
                    marginTop="0px"
                  />
                  <Ratings
                    value={parseInt(Company?.future)}
                    label={t("potential")}
                    fontSize="10px"
                  />
                  <Ratings
                    value={parseInt(Company?.past)}
                    label={t("past_history")}
                    fontSize="10px"
                  />
                  <Ratings
                    value={parseInt(Company?.health)}
                    label={t("solvency")}
                    fontSize="10px"
                  />
                  <Ratings
                    value={parseInt(Company?.dividend)}
                    label={t("earnings")}
                    fontSize="10px"
                  />
                </Grid>
              </div>
            ) : null}

            {Company?.Graph ? (
              <Grid item xs={12}>
                <div
                  style={{
                    width: "100%",
                    height: "122px",
                  }}
                >
                  <CompanyChart
                    ISIN={Company?.ISIN}
                    yearlyView={yearlyView}
                    monthlyView={monthlyView}
                    changeGraph={changeGraph}
                    small={true}
                  />
                </div>
                <Grid item xs={12} style={{ display: "flex" }}>
                  <Chip
                    label="1M "
                    onClick={() => {
                      setYearlyView(false);
                      setMonthlyView(false);
                      setChangeGraph(!changeGraph);
                    }}
                    style={{
                      borderRadius: "10px",
                      color:
                        !yearlyView && !monthlyView ? "#f8f8f8" : "#808080",
                      backgroundColor:
                        !yearlyView && !monthlyView ? "#0040ff" : "#fff",
                      height: "20px",
                      width: "100%",
                      margin: "30px 30px 0 10px",
                      fontSize: "10px",
                      fontWeight: 400,
                      fontFamily: "Overpass",
                      display: "flex",
                      alignItems: "center",
                    }}
                  />
                  <Chip
                    label="YTD"
                    onClick={() => {
                      setMonthlyView(true);
                      setYearlyView(false);
                      setChangeGraph(!changeGraph);
                    }}
                    style={{
                      borderRadius: "10px",
                      color: monthlyView ? "#f8f8f8" : "#808080",
                      backgroundColor: monthlyView ? "#0040ff" : "#f8f8f8",
                      marginRight: "10px",
                      height: "20px",
                      margin: "30px 30px 0 10px",
                      fontSize: "10px",
                      fontWeight: 400,
                      fontFamily: "Overpass",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  />

                  <Chip
                    label="ALL"
                    onClick={() => {
                      setYearlyView(true);
                      setMonthlyView(false);
                      setChangeGraph(!changeGraph);
                    }}
                    style={{
                      borderRadius: "10px",
                      color: yearlyView ? "#f8f8f8" : "#808080",
                      backgroundColor: yearlyView ? "#0040ff" : "#f8f8f8",
                      marginRight: "10px",
                      height: "20px",
                      margin: "30px 30px 0 10px",
                      fontSize: "10px",
                      fontWeight: 400,
                      fontFamily: "Overpass",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  />
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </>
      ) : null}
      <Grid item xs={isDesktopOrLaptop ? "auto" : 12}>
        <div style={{ height: isDesktopOrLaptop ? "200px" : "auto" }}>
          <Typography
            style={{
              fontSize: isDesktopOrLaptop ? "32px" : "24px",
              fontWeight: isDesktopOrLaptop ? 900 : "bold",
              fontFamily: "Overpass",
              color: "#16063b",
              paddingBottom: isDesktopOrLaptop ? "20px" : "6px",
            }}
          >
            {Company?.Name}
          </Typography>
          <a
            href={website}
            target="_blank"
            style={{
              fontSize: "16px",
              fontWeight: 400,
              fontFamily: "Overpass",
              color: "#0040ff",
            }}
          >
            {website}
          </a>
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
              fontFamily: "Overpass",
              color: "#0040ff",
            }}
          >
            <span style={{ color: "#808080" }}>ISIN: </span> {ISIN}
          </p>
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
              fontFamily: "Overpass",
              color: "#0040ff",
            }}
          >
            <span style={{ color: "#808080" }}>{t("sector")} </span>{" "}
            {Company?.Sector}
          </p>
        </div>
        {isDesktopOrLaptop ? null : (
          <>
            {Company?.valuation ||
            Company?.future ||
            Company?.past ||
            Company?.health ||
            Company?.dividend ? (
              <>
                <Ratings
                  value={parseInt(Company?.valuation)}
                  label={t("fair_price")}
                  fontSize="10px"
                />
                <Ratings
                  value={parseInt(Company?.future)}
                  label={t("potential")}
                  fontSize="10px"
                />
                <Ratings
                  value={parseInt(Company?.past)}
                  label={t("past_history")}
                  fontSize="10px"
                />
                <Ratings
                  value={parseInt(Company?.health)}
                  label={t("solvency")}
                  fontSize="10px"
                />
                <Ratings
                  value={parseInt(Company?.dividend)}
                  label={t("earnings")}
                  fontSize="10px"
                />
              </>
            ) : null}
            {Company?.Graph ? (
              <>
                <div
                  style={{
                    width: "100%",
                    height: "156px",
                    paddingTop: "32px",
                  }}
                >
                  <CompanyChart
                    ISIN={Company?.ISIN}
                    yearlyView={yearlyView}
                    monthlyView={monthlyView}
                    changeGraph={changeGraph}
                    small={true}
                  />
                </div>
                <Grid item xs={12} style={{ display: "flex" }}>
                  <Chip
                    label="1M "
                    onClick={() => {
                      setYearlyView(false);
                      setMonthlyView(false);
                      setChangeGraph(!changeGraph);
                    }}
                    style={{
                      borderRadius: "10px",
                      color:
                        !yearlyView && !monthlyView ? "#f8f8f8" : "#808080",
                      backgroundColor:
                        !yearlyView && !monthlyView ? "#0040ff" : "#fff",
                      height: "20px",
                      width: "100%",
                      margin: "30px 30px 0 10px",
                      fontSize: "10px",
                      fontWeight: 400,
                      fontFamily: "Overpass",
                      display: "flex",
                      alignItems: "center",
                    }}
                  />
                  <Chip
                    label="YTD"
                    onClick={() => {
                      setMonthlyView(true);
                      setYearlyView(false);
                      setChangeGraph(!changeGraph);
                    }}
                    style={{
                      borderRadius: "10px",
                      color: monthlyView ? "#f8f8f8" : "#808080",
                      backgroundColor: monthlyView ? "#0040ff" : "#f8f8f8",
                      marginRight: "10px",
                      height: "20px",
                      margin: "30px 30px 0 10px",
                      fontSize: "10px",
                      fontWeight: 400,
                      fontFamily: "Overpass",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  />

                  <Chip
                    label="ALL"
                    onClick={() => {
                      setYearlyView(true);
                      setMonthlyView(false);
                      setChangeGraph(!changeGraph);
                    }}
                    style={{
                      borderRadius: "10px",
                      color: yearlyView ? "#f8f8f8" : "#808080",
                      backgroundColor: yearlyView ? "#0040ff" : "#f8f8f8",
                      marginRight: "10px",
                      height: "20px",
                      margin: "30px 30px 0 10px",
                      fontSize: "10px",
                      fontWeight: 400,
                      fontFamily: "Overpass",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  />
                </Grid>{" "}
              </>
            ) : null}
          </>
        )}
        <p
          style={{
            fontSize: "16px",
            fontWeight: 400,
            fontFamily: "Overpass",
            color: "#808080",
            marginRight: isDesktopOrLaptop ? "98px" : "0",
            marginTop: "32px",
          }}
        >
          {description}
        </p>
        <p
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            fontFamily: "Overpass",
            color: "#16063b",
            marginTop: "40px",
          }}
        >
          {t("financials")}
        </p>
        <Financials values={financials} cur={Company?.Currency} t={t} />
        <p
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            fontFamily: "Overpass",
            color: "#16063b",
            marginTop: "40px",
            marginBottom: "20px",
          }}
        >
          {t("key_executives")}
        </p>
        <KeyExectives values={keyExectives} t={t} />
      </Grid>
    </div>
  );
}
